import { journeyAction, } from './base';

import { JourneyActionVoiceSayNumber as JourneyActionVoiceSayNumberBase, } from 'atlas-shared';

export const JourneyActionVoiceSayNumber = journeyAction({
  ...JourneyActionVoiceSayNumberBase,
  icon: 'Numbers',
});
